// Set video duration and autoplay delay for slides with videos
const videos = document.querySelectorAll(".story__slide video");
videos.forEach((video) => {
  video.addEventListener("loadedmetadata", () => {
    const closestSlide = video.closest(".story__slide");
    const autoplayDuration = video.duration * 1000;
    closestSlide.setAttribute("data-swiper-autoplay", autoplayDuration);
  });
});

// Initialize Instagram Swiper slider only if not already initialized
function initializeInstagramSlider() {
  if (typeof Swiper === "undefined") {
    setTimeout(initializeInstagramSlider, 100);
    return;
  }

  const storySlider = document.querySelector(".story__slider");
  if (!storySlider || storySlider.swiper) {
    return; // Already initialized or doesn't exist
  }

  const slider = new Swiper(".story__slider", {
    speed: 1,
    watchSlidesProgress: true,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    width: null,
    navigation: {
      nextEl: ".story__next",
      prevEl: ".story__prev",
    },
    pagination: {
      el: ".story__pagination",
      renderBullet(index, className) {
        return `<div class="${className}"><div class="swiper-pagination-progress"></div></div>`;
      },
    },
    on: {
      autoplayTimeLeft(swiper, time, progress) {
        const currentSlide = document.querySelector(
          ".story__slider .swiper-slide-active"
        );
        const currentBullet = document.querySelectorAll(
          ".story__slider .swiper-pagination-progress"
        )[swiper.realIndex];
        const fullTime =
          parseInt(currentSlide.dataset.swiperAutoplay) ||
          swiper.params.autoplay.delay;

        const percentage = `${Math.min(
          Math.max(((fullTime - time) * 100) / fullTime, 0),
          100
        ).toFixed(1)}%`;
        if (typeof gsap !== "undefined") {
          gsap.set(currentBullet, { width: percentage });
        }
      },
      transitionEnd(swiper) {
        const allBullets = document.querySelectorAll(
          ".story__slider .swiper-pagination-progress"
        );
        const bulletsBefore = Array.from(allBullets).slice(0, swiper.realIndex);
        const bulletsAfter = Array.from(allBullets).slice(swiper.realIndex);

        if (typeof gsap !== "undefined") {
          gsap.set(bulletsBefore, { width: "100%" });
          gsap.set(bulletsAfter, { width: "0%" });
        }

        const activeSlide = document.querySelector(
          ".story__slider .swiper-slide-active"
        );
        const video = activeSlide.querySelector("video");
        if (video) {
          video.currentTime = 0;
          video.play();

          // Pause the swiper autoplay
          swiper.autoplay.stop();

          // Update progress bar as video plays
          video.ontimeupdate = () => {
            const currentBullet = document.querySelectorAll(
              ".story__slider .swiper-pagination-progress"
            )[swiper.realIndex];
            const percentage = `${(
              (video.currentTime / video.duration) *
              100
            ).toFixed(1)}%`;
            if (typeof gsap !== "undefined") {
              gsap.set(currentBullet, { width: percentage });
            }
          };

          // Resume the swiper autoplay when the video ends
          video.onended = () => {
            swiper.autoplay.start();
            swiper.slideNext();
          };
        } else {
          swiper.autoplay.start();
        }
      },
    },
  });

  // Force resize on mobile devices
  function forceSliderResize() {
    if (window.innerWidth <= 749) {
      const storySlider = document.querySelector(".story__slider");
      const storyWrapper = document.querySelector(".story__wrapper");
      const slides = document.querySelectorAll(".story__slide");

      if (storySlider) {
        storySlider.style.width = "100vw";
        storySlider.style.maxWidth = "100vw";
      }

      if (storyWrapper) {
        storyWrapper.style.width = "100vw";
        storyWrapper.style.maxWidth = "100vw";
      }

      slides.forEach((slide) => {
        slide.style.width = "100vw";
        slide.style.minWidth = "100vw";
      });

      // Force Swiper to update
      if (slider && slider.update) {
        slider.update();
      }
    }
  }

  // Call on load and resize
  window.addEventListener("load", forceSliderResize);
  window.addEventListener("resize", forceSliderResize);

  // Also call after a short delay to ensure everything is loaded
  setTimeout(forceSliderResize, 100);
  setTimeout(forceSliderResize, 500);
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initializeInstagramSlider);

// Also try on window load as backup
window.addEventListener("load", initializeInstagramSlider);
